/** Limite le poids mémoire — évite « Page Unresponsive » sur grosses cartos. */
export const MAX_EXPORT_LONG_EDGE_PX = 8192;
export const MAX_EXPORT_PIXELS = 12_000_000;

/** Scale adaptatif : qualité suffisante sans saturer la mémoire. */
export function computeAdaptiveExportScale(
  width: number,
  height: number,
  currentViewScale = 1,
  devicePixelRatio = typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1,
): number {
  const safeW = Math.max(1, width);
  const safeH = Math.max(1, height);
  const dpr = Math.min(devicePixelRatio, 2);
  let scale = Math.max(1.25, dpr * 1.25);

  const longEdge = Math.max(safeW, safeH);
  const scaleByLongEdge = MAX_EXPORT_LONG_EDGE_PX / longEdge;
  const scaleByPixels = Math.sqrt(MAX_EXPORT_PIXELS / (safeW * safeH));
  scale = Math.min(scale, scaleByLongEdge, scaleByPixels);

  if (currentViewScale > 1) {
    scale = Math.min(scale * 1.05, scaleByLongEdge, scaleByPixels);
  }

  return Math.min(Math.max(scale, 0.5), 2.5);
}
